import { Icon } from '@imprivata-cloud/design-system';

import ImprivataLogo from '../../assets/Imprivata_Logo.svg?react';
import './insufficient-factors.less';

export const InsufficientFactors = () => {
  return (
    <div className="insufficient-factors-root">
      <div className="content">
        <Icon type="warning" className="insufficient-factors-icon" />
        <h2 className="insufficient-factors-title">
          You haven't added the required authentication methods
        </h2>
        <p className="insufficient-factors-text">
          Authentication requires more than one authentication method. Contact
          your help desk for assistance enrolling an additional method.
        </p>
      </div>
      <div className="footer">
        <ImprivataLogo />
      </div>
    </div>
  );
};
